import cx from 'classnames';
import { forwardRef, HTMLProps, PropsWithChildren } from 'react';
import './layout.scss';

interface ILayoutProps {
	className?: string;
	flex?: boolean;
	wrap?: boolean;
	column?: boolean;
	row?: boolean;
	justifyContent?: string;
	style?: Record<string, string | number>;
}

export const Layout = forwardRef<
	HTMLDivElement,
	PropsWithChildren<
		Omit<HTMLProps<HTMLDivElement>, keyof ILayoutProps> & ILayoutProps
	>
>(
	(
		{
			className,
			flex,
			wrap = flex,
			row,
			column = flex && !row,
			justifyContent,
			children,
			style,
			...props
		},
		ref,
	) => (
		<div
			{...props}
			className={cx(className, {
				layout__flex: flex,
				'layout__flex-wrap': wrap,
				'layout__flex-column': column && !row,
				'layout__flex-row': row && !column,
			})}
			style={{ ...style, justifyContent }}
			ref={ref}
		>
			{children}
		</div>
	),
);
